import type { IntegrationOperationStatusDto } from '../../api/types';

/**
 * Operaciones que alimentan otros sistemas por la API de integración: facturación y pagos (FC_FACTURA, FC_PAGO) y cajas.
 * Sus plantillas se configuran sólo en Configuración → Integración; el inventario usa cuentas por categoría (pantalla
 * Inventario). El resto de operaciones (CxC, CxP, bancos, planilla) se asignan en Plantillas → "Plantillas por operación".
 */
export const INTEGRATION_OPERATIONS = ['FC_FACTURA', 'FC_PAGO', 'CAJA_INGRESO', 'CAJA_EGRESO', 'CAJA_FALTANTE', 'CAJA_SOBRANTE'];

export const baseOf = (o: Pick<IntegrationOperationStatusDto, 'operation' | 'baseOperation'>) => o.baseOperation || o.operation.split('@')[0];

export const isIntegrationOperation = (o: Pick<IntegrationOperationStatusDto, 'operation' | 'baseOperation'>) =>
  INTEGRATION_OPERATIONS.includes(baseOf(o).toUpperCase());

/** Plantillas asignadas a operaciones de integración ("módulo-código"), para ocultarlas de la lista general. */
export const integrationTemplateKeys = (ops: IntegrationOperationStatusDto[] | null | undefined) =>
  new Set((ops ?? []).filter((o) => isIntegrationOperation(o) && o.source === 'DB' && o.templateCode).map((o) => `${o.moduleCode}-${o.templateCode}`));
